import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { SharedService } from "@core/services/shared/shared.service";
import { Subscription, timer } from "rxjs";
import { Router } from '@angular/router';
import { filter, finalize, takeUntil, takeWhile, tap } from "rxjs/operators";
import { Subject, forkJoin, Observable } from "rxjs";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ManageTimeService } from "@core/components/manage-time-session/manage-time-session.service";
import { manageStorageService } from "@core/services/manage-storage/manage-storage.service";
import { ApiService } from "@core/services/api";
import { SignOutService } from "app/modules/public/sign-out/sign-out.service";
import { UtilsService } from "@core/services/utils";
@Component({
  selector: "manage-time-session",
  templateUrl: "./manage-time-session.component.html",
  styleUrls: ["./manage-time-session.component.scss"],
})
export class ManageTimeSessionComponent implements OnInit, OnDestroy {

  // -----------------------------------------------------------------------------------------------------
  // @ Decorators
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  /** constructor  */
  // -----------------------------------------------------------------------------------------------------
  constructor(
    private _api: ApiService,
    private _utilS: UtilsService,
    private _allModals: MatDialog,
    private _signOutS: SignOutService,
    private _sharedInfo: SharedService,
    private _mTimeSrvc: ManageTimeService,
    private _mStorage: manageStorageService,
    public _timeModal: MatDialogRef<ManageTimeSessionComponent>, // this window
  ) { }

  // -----------------------------------------------------------------------------------------------------
  // @ Public declaration vars
  // -----------------------------------------------------------------------------------------------------
  status: any;
  resetFlag: boolean;
  countdown: number = 30;

  // -----------------------------------------------------------------------------------------------------
  // @ Private declaration vars
  // -----------------------------------------------------------------------------------------------------
  private _unsubscribeMngeTime: Subject<void> = new Subject();

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  ngOnInit() {

    this._sharedInfo.getData
      .pipe(
        filter((value) => !this._utilS.isEmpty(value)),
        takeUntil(this._unsubscribeMngeTime)
      )
      .subscribe((dataRecieve) => {
        switch (dataRecieve.origin) {
          case "timeSession":
            Swal.close();
            this.countdown = dataRecieve.data?.countdown || 0;
            break;

          case "renewCBSession":
            this.initCountDown()
            break;
        }

      });

    this.reviewFlag(true);
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeMngeTime.next();
    this._unsubscribeMngeTime.complete();
    this.resetFlag = false;
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------
  private initCountDown() {

    timer(1000, 1000)
      .pipe(
        finalize(() => { this.reviewFlag(false); }),
        takeWhile(() => this.countdown > 0),
        takeUntil(this._unsubscribeMngeTime),
        tap(() => this.countdown--)
      )
      .subscribe();

  }
  /**
   * [reviewFlag]
   * @param status
   * revisa que se haya dado click en renovar la sesion
   */
  private reviewFlag(status: boolean): void {
    this.resetFlag = status;
    setTimeout(() => {
      if (this.resetFlag === true) {
        this.closeSession();
      }
    }, this.countdown * 1000);
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------


  /**
   * ! [closeSession]
   * * press button close session and no renew 
   */
  closeSession() {
    this._allModals.closeAll();
    this.resetFlag = false;
    this._api.logOut()
      .then(() => this._signOutS.processToLogOut(), () => this._signOutS.processToLogOut())
      .catch((errLgOut) => { this._signOutS.processToLogOut(); console.error(errLgOut) })
  }

  /**
   * ! [renewSession]
   * * press button and   renewJwt  session 
   */
  async renewSession() {
    this.resetFlag = false;
    this._timeModal.close();
    try {
      const rspRenwJWT = await this._mTimeSrvc.renwJWTSessn();
      console.log('%c🪴 renwPlantpotSessn', 'color: green');
    } catch (erroRenewJWT) {
      this.closeSession();
    }
  }


}
